import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo, useCallback, Dispatch, SetStateAction } from "react";
import { useParams } from "react-router-dom";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { Toast } from "../../components/atom/Toast/Toast";
import { CellProps, Column } from "react-table";
import { primaryColor } from "../../utils/colors";
import SwitchComponent from "../../components/atom/Switch/SwitchComponent";
import { handleOnChangeStateItem } from "./controller/ChangeStatus";
import { AuthUser } from "../../types/User/AuthUser";

interface TableAuxiliaresItemsProps {
  setIdUpdateItem: (id: number) => void;
  setDataTable: Dispatch<SetStateAction<any[]>>;
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>;
  dataTable: any[];
  isLoaded: boolean;
  openModal: (newTitle: string, newButtonTitle: string) => void;
  setValue: (key: string, value: any) => void;
  user: AuthUser;
}

const TableAuxiliaresItems: FC<TableAuxiliaresItemsProps> = ({
  setIdUpdateItem,
  setDataTable,
  setOriginalDataTable,
  dataTable,
  isLoaded,
  openModal,
  setValue,
  user,
}) => {
  const { table } = useParams<{ table: string }>();
  const { addToast } = Toast();

  const handleStateChange = useCallback(
    (id: number, enabled: boolean) => {
      if (table) {
        handleOnChangeStateItem(
          id,
          enabled,
          table,
          setDataTable,
          setOriginalDataTable,
          addToast,
        );
      }
    },
    [table, setDataTable, setOriginalDataTable, addToast],
  );

  const hasProvinceColumn = useMemo(
    () => dataTable.some((row) => row.province),
    [dataTable],
  );

  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "ID", accessor: "id" },
      { Header: "Nome", accessor: "name" },
      { Header: "Código", accessor: "code" },
      {
        Header: "Estado",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <SwitchComponent
            isActive={row.original.isActive}
            onChange={handleStateChange}
            value={row.original.id}
            color={primaryColor}
          />
        ),
      },
    ];

    if (user?.permissions && user.permissions.includes("ManageLookups")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                openModal(`Editar item ${row.original.name}`, "Guardar");
                setIdUpdateItem(row.original.id);
                setValue("name", row.original.name);
                setValue("code", row.original.code);
                if (hasProvinceColumn && row.original.province) {
                  setValue("province", row.original.province);
                }
              }}
            />
          </Center>
        ),
      });
    }

    if (hasProvinceColumn) {
      baseColumns.splice(3, 0, {
        Header: "Província",
        accessor: "province.name",
      });
    }

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    handleStateChange,
    setIdUpdateItem,
    setValue,
    openModal,
    hasProvinceColumn,
  ]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "edit", hasShadow: true }]}
    />
  );
};

export default TableAuxiliaresItems;
